import React from "react";
import { ArrowRight, Quote } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/common";
import { PROBLEM_QUOTES } from "@/data/content";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const ProblemSection = () => {
  return (
    <section id="problem" data-testid="problem-section" className="relative py-20 sm:py-28 bg-[#f7faf8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            overline="The problem"
            title="Work should not end with begging."
            subtitle="Vendors do the work. Then come the excuses."
            center
          />
        </Reveal>

        <div className="mt-12 flex gap-4 overflow-x-auto no-scrollbar pb-2 snap-x lg:grid lg:grid-cols-3 lg:gap-5 lg:overflow-visible">
          {PROBLEM_QUOTES.map((q, i) => (
            <Reveal key={q} delay={(i % 3) * 0.05}>
              <div
                data-testid={`quote-card-${i}`}
                className="snap-center shrink-0 w-64 lg:w-auto bg-white rounded-2xl border border-slate-100 p-6 soft-shadow"
              >
                <Quote className="h-6 w-6 text-slate-200 mb-3" />
                <p className="text-lg font-semibold text-[#091630] italic">"{q}"</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 text-center">
            <p className="font-display text-2xl sm:text-3xl font-extrabold text-[#091630]">
              Workpay gives vendors a <span className="text-gradient">better default.</span>
            </p>
            <button
              data-testid="problem-cta"
              onClick={() => scrollTo("#early-access")}
              className="mt-7 inline-flex items-center gap-2 bg-[#21c55e] text-[#091630] font-bold py-3.5 px-7 rounded-full hover:bg-[#16a34a] hover:text-white transition-colors green-shadow"
            >
              Make Workpay your payment link <ArrowRight className="h-5 w-5" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ProblemSection;
